import { Checkbox } from 'shadcdn/ui/checkbox'
import { Label } from 'shadcdn/ui/label'
import { useAllowInstalledTracking } from 'features/installed-software/hooks'

export const SettingsPage = () => {
  const [allowTracking, setAllowInstalledTracking] = useAllowInstalledTracking()

  const handleInstalledSoftwareTrackingChange = (isEnabled: boolean) => {
    const trackingPreference = isEnabled ? 'anonymous' : 'deny'
    setAllowInstalledTracking(trackingPreference)
    // This change allows us to collect anonymous data about installed plugins,
    // which helps us develop auto-update features and prioritize plugin integration.
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Settings</h1>
      <div className="items-top flex space-x-2">
        <Checkbox
          id="installed-software-tracking"
          checked={allowTracking === 'anonymous'}
          onCheckedChange={handleInstalledSoftwareTrackingChange}
        />
        <div className="grid gap-1.5 leading-none">
          <Label
            htmlFor="installed-software-tracking"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Enable installed software data collection
          </Label>
          <p className="text-xs text-muted-foreground mt-1">
            <p className="mb-1">
              We anonymously collect data about your installed plugins to build auto-update functionality and understand
              what plugins should be added to the app.
            </p>
            <p className="mb-1">No personal information is collected and the data is not shared with anyone.</p>
          </p>
        </div>
      </div>
    </div>
  )
}
